import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import useStore from "stores/index";

const RoomsList = (props) => {
	const classroom = useStore
		.getState()
		.classroom.getClassrooms()
		.find((classroom) => classroom.sourceId === props.classroomId);
	const className = classroom.label || classroom.name;
	const displayName = classroom?.personalisation?.displayName || className;
	return (
		<button className="ClassroomChatroom_rowContainer" data-classid={props.classroomId} onClick={props.onClick} type="button">
			<div className="Classroom_rowWrapper">
				<div className="ClassroomChatroom_classInfo">
					<div className="ClassroomChatroom_name">{displayName}</div>
					{props.isActiveClass ? (
						<span className="ClassroomChatroom_status ClassroomChatroom_active">{`${props.studentCount} student${
							props.studentCount === 1 ? "" : "s"
						}`}</span>
					) : (
						<span className="ClassroomChatroom_status ClassroomChatroom_inactive">Class offline</span>
					)}
				</div>
				{!!props.hasUnreadMessages && (
					<div className={clsx("ClassroomChat_notificationsContainer")}>
						<div className="ClassroomChat_notificationsValue"></div>
					</div>
				)}
			</div>
		</button>
	);
};

export default RoomsList;

RoomsList.propTypes = {
	classroomId: PropTypes.string,
	isActiveClass: PropTypes.bool,
	hasUnreadMessages: PropTypes.bool,
	onClick: PropTypes.func,
	studentCount: PropTypes.number,
};
